export const CHECKOUT_PLAN_RADIO = 'checkout_plan_radio';
